import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ValidatorFn } from '@angular/forms';
import { PermissionEnum } from '@app/core/enums/permissions.enum';
import { ValidatorType } from '@app/core/enums/validator-type.enum';
import { FieldValidator } from '@app/core/model/other/field-validator';
import { AbstractFieldBuilder } from '@app/shared/components/fields/abstract.field';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';


@Component({
    selector: 'multivalue-field-builder',
    templateUrl: './multivalue-field-builder.component.html',
    styleUrls: ['./multivalue-field-builder.component.scss'],
    standalone: false
})
export class MultivalueFieldBuilderComponent extends AbstractFieldBuilder<FormControl> implements OnInit, AfterViewInit {
  public Permission = PermissionEnum;

  public ngOnInit(): void {
    this.form = new FormGroup({
      field: new FormControl(
        this.fieldInitValue,
        this.computeValidators()
      )
    });
    // Initialise the field in the registry
    this.setFieldValue(this.fieldInitValue);
    this.setFieldInitialValue(this.fieldInitValue);
    this.getNextState();
  }

  public ngAfterViewInit(): void {
    this.setupHooks();

    this.form.controls.field.valueChanges.pipe(
      distinctUntilChanged(),
      debounceTime(50),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe((value) => {
      this.setFieldValue(value);
    });
  }

  public cancel(): void {
    this.form.controls.field.setValue(this.getFieldInitialValue());
    super.cancel();
  }

  protected computeValidators(): ValidatorFn {
    this.fieldConfig.field?.validators.push(new FieldValidator(
      ValidatorType.NOT_IN_ARRAY,
      this.fieldConfig.field?.fieldValues
    ));
    return super.computeValidators();
  }
}
